// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GalleryPhotoPagination-style__wrapper__1sb5g","pagination":"GalleryPhotoPagination-style__pagination__1pvFS"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/components/GalleryPhotoPagination-style.scss
// module id = 1041
// module chunks = 4 22 26 29